import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import BadgeTable from '../components/BadgeTable';

const i18nPrefix = 'BadgeTable';

class Badge extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <Container style={{ maxHeight: 'none', backgroundColor: 'white' }}>
        <Row>
          <Col sm={4}>
            <div style={{ overflow: 'hidden' }}>
              <h1 style={{ float: 'left' }}>
                {t(`${i18nPrefix}.title`, 'Badge management')}
              </h1>
            </div>
          </Col>
        </Row>

        <BadgeTable {...this.props} />
      </Container>
    );
  }
}

export default withTranslation()(Badge);
